<template>
  <div class="main-container user-table-height">
    <div style="width: 100%">
      <el-input
        style="max-width: 200px"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :columns="isACxTeam ? cxTeamFields : fields"
        :rows="users"
        :search-options="{ enabled: true, externalQuery: searchTerm }"
        :pagination-options="{ enabled: true }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- {{1}} -->
          <span v-if="props.column.field == 'full_name'"
            >{{ props.row.firstName }} {{ props.row.lastName }}</span
          >
          <span v-if="props.column.field === 'gender'">
            <!-- {{ props.row.gender === "0" ? "Female" : "Male" }} -->

            {{ `${props.row.gender}` === "0" ? "Female" : "Male" }}
          </span>

          <span v-if="props.column.field == 'actions'">
            <router-link :to="`/users/priviledges/${props.row.id}`">
              <b-button size="md" variant="info">
                Priviledges &nbsp;
                <span class="fa fa-wrench"></span>
              </b-button>
            </router-link>
            <b-button
              size="md"
              variant="success"
              @click.stop="navTo(`/users/edit/${props.row.id}`, props.row)"
            >
              Edit &nbsp;
              <span class="fa fa-pencil-square-o"></span>
            </b-button>
          </span>
          <!-- <span v-else>{{ props.row[props.column.field] }}</span> -->
          <span v-if="props.column.field === 'updatedAt'">
            {{ props.row.updatedAt }}
          </span>
          <span v-if="props.column.field === 'id'">
            {{ props.row.id }}
          </span>
          <span v-if="props.column.field === 'roleType'">
            {{ props.row.roleType }}
          </span>
          <span v-if="props.column.field === 'email'">
            {{ props.row.email }}
          </span>
          <span v-if="props.column.field === 'phoneNumber'">
            {{ props.row.phoneNumber }}
          </span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import moment from "moment";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

const items = [];
export default {
  // components: {
  //   Inventory
  // },
  data() {
    return {
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      users: [],
      items: items,
      fields: [
        {
          field: "id",
          label: "ID",
          sortable: "true"
        },
        {
          field: "full_name",
          label: "Full Name",
          sortable: "true"
        },
        {
          field: "roleType",
          label: "User Type",
          sortable: "true"
        },
        {
          field: "email",
          label: "E-mail",
          sortable: "true"
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: "gender",
          label: "Gender",
          sortable: "true"
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: "phoneNumber",
          label: "Phone Number",
          sortable: "true"
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: "updatedAt",
          label: "Last Seen",
          sortable: "true"
        }
      ],
      cxTeamFields: [
        {
          field: "id",
          label: "ID",
          sortable: "true"
        },
        {
          field: "full_name",
          label: "Full Name",
          sortable: "true"
        },
        {
          field: "roleType",
          label: "User Type",
          sortable: "true"
        },
        {
          field: "email",
          label: "E-mail",
          sortable: "true"
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: "gender",
          label: "Gender",
          sortable: "true"
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: "phoneNumber",
          label: "Phone Number",
          sortable: "true"
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: "updatedAt",
          label: "Last Seen",
          sortable: "true"
        },
        {
          field: "actions",
          label: "Actions"
        }
      ],
      currentPage: 1,
      details: ["UserDetails", "allowUser"],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },
  computed: {
    ...mapGetters(["getUserById", "getDeviceById", "getDummy", "getDevices"]),
    isACxTeam: {
      get() {
        if (this.$can("am", "cxTeam") || this.$can("edit", "user")) {
          return true;
        } else {
          return true;
        }
      }
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("Do MMM YYYY");
    },
    navTo(url, user) {
      // console.log("wetin dey xup naw", user, url);
      this.$router.push({
        path: url,
        query: {
          user: user
        }
      });
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fetchUsers() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      // const url =
      //   `/users?filter[include][installations]=deviceType&filter[where][roleType][neq]=CUSTOMER` +
      //   `&filter[order]=id DESC`;

      const url = `/users/solarbase-users-only`;
      HTTP.get(url)
        .then(response => {
          container.users = response.data.users;
          // console.log('hello word +++++++++++++++++++++++++++++++++', container.users);
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  mounted() {
    this.fetchUsers();
  }
};
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

table th,
table th span {
  font-size: 0.7em;
}
.user-table-height {
  height: calc(100vh - 375px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/users/index.vue